var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kbd',{staticClass:"mr-2"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-tag")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }